import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box, Grid, Tab, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { TabsChildren } from "../../../../../logbook/pages/main/components/access/utils/enums/tabs"
import { useStyles } from "./styles"
import { SyntheticEvent } from "react"
import { Step2Props } from "./types"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { AddUsersFiles } from "../addUsers"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { SnackSimple } from "../../../../../../components"
import { useContextState } from "../../../../../../hooks/theme"
import { PermissionAsssignment } from "../permissionAssignment"



export const Permissions = ({ submitLoading, handleCancel, handleSubitmit, haveButtons, setValue, value, unSelectOrSelectAllUsersFolios, rowFiltered, permissionFilter, setDeletedSelected, deletedUsersSelecteds, deleteSelected, loadingTable, columnFolio, inputFilter, closeModal, openModal, closeSnackbar, snackbar, createFilter, input, modalLoad, loadings, cancelSearchUsers, searchUsers, loadUsers }:Step2Props) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()
    
    const handleChange = (_: SyntheticEvent | null, newValue: TabsChildren) => {
        setValue(newValue);
    }

    return (
        <Box>
            <Box sx={styles.tabsContainer}>
                <TabContext value={value}>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <Typography sx={styles.titlesTab}>
                                { value == TabsChildren.USERS ? t('filesManager.titles.selectUsersToAccess') : t('filesManager.titles.usersWithPermission') }
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <TabList sx={[styles.TabList]} onChange={handleChange} centered>
                                <Tab label={t('filesManager.tabsChildren.addUsers').toUpperCase()} value={TabsChildren.USERS} />
                                <Tab label={t('filesManager.tabsChildren.permissions').toUpperCase()} value={TabsChildren.PERMISSIONS} />
                            </TabList>
                        </Grid>
                    </Grid>

                    <TabPanel value={TabsChildren.USERS} sx={styles.TabPanel}>
                        <AddUsersFiles
                            cleanFilter={() => { createFilter.cleanFilter() }}
                            counter={createFilter.counter ?? 0}
                            lastStep={1}
                            rigthItem={<DinamicForm input={Object.values(input)} onChange={createFilter.onChange} errors={createFilter.errors} values={createFilter.filterData} />}
                            userList={modalLoad?.tmpUsuers as Record<string, string>[]}
                            open={false}
                            close={cancelSearchUsers}
                            userAmount={modalLoad?.tmpUsuers?.length ?? 0}
                            searchButton={{
                                disabled: !createFilter.query?.filter,
                                loading: !!loadings.search,
                                onClick: searchUsers
                            }}
                            addMessage
                            loadData={{
                                loading: !!loadings.load,
                                onClick: loadUsers
                            }}
                        />
                    </TabPanel>

                    <TabPanel value={TabsChildren.PERMISSIONS} sx={styles.TabPanel}>
                        <PermissionAsssignment
                            loadingTable={loadingTable}
                            deleteSelected={deleteSelected}
                            deletedUsersSelecteds={deletedUsersSelecteds}
                            setDeletedSelected={setDeletedSelected}
                            floatItems={<DinamicForm input={Object.values(inputFilter)} values={permissionFilter.filterData} onChange={permissionFilter.onChange} errors={permissionFilter.errors} filter={true} />}
                            cleanFilter={permissionFilter.cleanFilter}
                            counter={permissionFilter.counter}
                            rowFiltered={rowFiltered}
                            columnFolio={columnFolio}
                            unSelectOrSelectAllUsersFolios={unSelectOrSelectAllUsersFolios}
                            haveButtons={haveButtons}
                            handleCancel={handleCancel}
                            handleSubitmit={handleSubitmit}
                            submitLoading={submitLoading}
                        />
                    </TabPanel>
                </TabContext>
            </Box>
            <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
            <SimpleModal
                open={openModal.open}
                close={() => {
                    closeModal()
                }}
                title={openModal.title}
                description={openModal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                color={colors}
                back={() => {
                    closeModal()
                }}
                next={() => {
                    if (openModal?.confirm) {
                        openModal.confirm()
                    }
                }}
            />
        </Box>
    )
}